.panel {
  display: flex;
  flex-direction: column;
}

/* The mockup's `.toolbar`: the state tabs first, the artifact filter pushed to the right. */
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  margin-block-end: var(--space-4);
}

.spacer {
  flex: 1;
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.content:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

/* The mockup's `select` in the toolbar is as wide as its text, not the row. */
.artifact {
  display: inline-block;
  min-inline-size: 176px;
}
